<template>
  <div>
    <van-nav-bar
      :title="$t('app.register.register')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/login')"
    />
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img
          :src="require('../assets/images/' + $store.state.login_logo_img)"
          style="width: 100%"
          v-if="!$store.state.login_logo_url"
        />
      </div>
      <div>
        <p style="text-align: center; font-size: 19px; color: red">
          {{$t("app.register.newMember_gift")}}
        </p>
        <p style="text-align: center; display: none">{{$t("app.register.newMember_gift1")}}</p>
        <p style="text-align: center; font-size: 15px">
          {{$t("app.register.register")}}<span style="color: red"
            >&nbsp;{{ sys_give_voucher_amount }}&nbsp;{{$t("app.common.currency")}}</span
          >&nbsp;+&nbsp;{{$t("app.register.first_deposit")}}&nbsp;<span style="color: red"
            >10000&nbsp;{{$t("app.common.currency")}}&nbsp;</span
          >
          <!-- +&nbsp;交易&nbsp;<span style="color: red">9999&nbsp;{{$t("app.common.currency")}}</span> -->
        </p>
        <p style="padding-top: 5px; color: red; text-align: center">
          {{$t("app.register.newMember_gift1_1")}}&nbsp;{{ sys_give_voucher_amount }}&nbsp;{{$t("app.common.currency")}}
        </p>
      </div>
      <van-form @submit="onRegister">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          :label="$t('app.register.phone')"
          :placeholder="$t('app.register.phone_placeholder')"
          autocomplete="off"
        />
        <van-field
          v-model="rePicCode"
          center
          clearable
          :label="$t('app.register.verification_code')"
          :placeholder="$t('app.register.verification_code_placeholder')"
        >
          <div slot="button">
            <img
              :src="captcha"
              @click="this.getCaptcha"
              style="height: 25px; width: 80px"
            />
          </div>
        </van-field>
        <van-field
          v-model="sms"
          center
          clearable
          :label="$t('app.register.sms_code')"
          :placeholder="$t('app.register.sms_code_placeholder')"
          autocomplete="off"
        >
          <template #button>
            <van-button
              size="small"
              plain
              type="info"
              native-type="button"
              @click="getPhoneCode"
              :disabled="disabled"
              >{{ getCodeText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="password"
          type="password"
          name="password"
          :label="$t('app.register.password')"
          :placeholder="$t('app.register.password_placeolder')"
          autocomplete="off"
        />
        <van-field
          v-model="recommend"
          name="recommend"
          :label="$t('app.register.recommender')"
          :placeholder="$t('app.register.recommender_placeholder')"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
          >
            {{$t("app.register.register")}}
          </van-button>
        </div>
      </van-form>
    </div>
    <van-popup
      v-model="isRegisterSuccess"
      style="width: 70%; height: 151px; overflow: hidden"
    >
      <div>
        <h5 style="padding-top: 1px; text-align: center">{{$t("app.register.success")}}</h5>
        <h5 style="padding-top: 1px; text-align: center">
          {{$t("app.register.login_to_receive")}}<span>&nbsp;{{ sys_give_voucher_amount }}&nbsp;</span
          >{{$t("app.register.gift_money")}}
        </h5>
        <span
          ><van-button
            type="danger"
            size="small"
            @click="cancel"
            style="
              width: 42%;
              margin-left: 5%;
              margin-bottom: 5%;
              border-radius: 5px;
            "
            >{{$t("app.common.cancel")}}
          </van-button>

          <van-button
            type="danger"
            size="small"
            @click="$router.push('/login')"
            style="
              width: 42%;
              margin-left: 5%;
              margin-bottom: 5%;
              border-radius: 5px;
            "
            >{{$t("app.register.loginNow")}}
          </van-button>
          <van-divider />
        </span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Register",
  data() {
    return {
      phone: "",
      password: "",
      sms: "",
      recommend: "",
      disabled: false,
      getCodeText: this.$t('app.register.get_code'),
      isRegisterSuccess: false,
      sys_give_voucher_amount: "",
      rePicCode: "",
      captcha: "",
      verify_token: "",
    };
  },
  methods: {
    // add public key encryption code when no key in local storage
    getEncyptedPublicKey() {
      let encriptedPublicKey = localStorage.getItem("encript_public_key");

      if (!encriptedPublicKey) {
        let that = this;
        const toast = that.$ShowCommonLoading();
        that
          .$http({
            url: "/",
            method: "POST",
            data: {
              nozzle: "home",
            },
          })
          .then((ret) => {
            let resData = ret.data;
            if (resData.code === 1) {
              toast.clear();
              localStorage.setItem(
                "encript_public_key",
                resData.data.encript_public_key
              );
            } else {
              toast.clear();
              that.$toast.fail(that.$t(resData.msg));
            }
          })
          .catch(() => {
            toast.clear();
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
      }
    },
    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "sys_give_voucher_amount",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            //first time Recharge
            that.sys_give_voucher_amount = res.data.data;
          } else {
          }
        });
    },
    getPhoneCode() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "register_code_e",
              rePicCode: that.rePicCode,
              phone: phoneNumber,
              verify_token: that.verify_token,
              },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
              });
              var time = 60;
              that.getCodeText = time + "s";
              that.disabled = true;
              var timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  that.getCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
            } else if (res.data.code == 0) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
      }
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    onRegister() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        let userPasword = that.encryptMessage(that.password, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "register_e",
              phone: phoneNumber,
              password: userPasword,
              code: that.sms,
              reid: that.recommend,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              // that.realNameConfig();
              that.isRegisterSuccess = true;
              // that.$toast({
              //   message: res.data.msg,
              //   type: "success",
              //   onClose:function () {
              //     that.$router.push('/login')
              //   }
              // });
            } else if (res.data.code == 0) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    cancel() {
      this.isRegisterSuccess = false;
    },
    login() {
      this.$router.push("/login");
    },
    isLogin() {
      let that = this;
      if (that.$store.state.loginType) {
        that.$router.push("/members");
      }
    },
    isCode() {
      let that = this;
      let code = this.$route.query.code;
      let rePhone = window.sessionStorage.getItem("rePhone");

      if (!code && !rePhone) {
        that.recommend = "";

        // that.rePhone = code;
      } else {
        if (!code == false) {
          that.recommend = code;
          window.sessionStorage.setItem("rePhone", code);
        } else if (!rePhone == false) {
          that.recommend = rePhone;
          window.sessionStorage.setItem("rePhone", rePhone);
        }
      }
    },
  },
  mounted: function () {
    this.getEncyptedPublicKey();
    this.realNameConfig();
    this.isLogin();
    this.isCode();
    this.getCaptcha();

  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 25px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue